import parse from "html-react-parser";
import get from "lodash.get";
import React, { memo, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NewsIcon from "../../../assets/images/icons/NewsIcon";
import Loader from "../../../assets/loader/Loader";
import { CancelButton } from "../../../assets/styles/Button";
import useOutsideClick from "../../../hooks/useOutsideClick/useOutsideClick";
import { useRequest } from "../../../hooks/useRequest/UseRequest";
import { REQUEST_STATUS } from "../../../hooks/useRequest/useRequest.constants";
import { CustomIconStyle, NewsBoxModal, NewsBoxStyle } from "./NewsBox.style";
import { CustomStyledIconButton } from "../../../styles/global.style";

interface INewsData {
  hasSeen: boolean;
  image: string;
  telegrafUrl?: string;
  title: string;
  content?: any;
  _id: string;
}
const NewsBox = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [newsData, setNewsData] = useState([]);
  const ref = useRef(null);

  const [getNewsClient, data, status] = useRequest();
  const [getByIdClient, getByIdData, getByIdStatus] = useRequest();

  const { t } = useTranslation();

  useOutsideClick(ref, () => {
    setOpen(false);
  });

  const getNews = async (page: number) => {
    const news = await getNewsClient.post("/platform-updates", {
      page,
      limit: 50,
    });

    if (news.data) {
      setNewsData(newsData.concat(news.data?.data));
    }
  };

  useEffect(() => {
    getNews(page);
  }, [page]);

  const handleClick = async (section: INewsData) => {
    setOpen(false);
    setModal(true);
    setNewsData([]);

    await getByIdClient.get(`/platform-updates/${section._id}`);
  };

  useEffect(() => {
    if (getByIdStatus === REQUEST_STATUS.success) {
      getNews(1);
    }
  }, [getByIdStatus]);

  const hasSeen = get(data, "data.data", []).find(
    (item: INewsData) => !item.hasSeen
  );

  const getMoreNews = async () => {
    setPage((prev) => prev + 1);
  };

  return (
    <NewsBoxStyle ref={ref}>
      <CustomStyledIconButton onClick={() => setOpen(!open)}>
        <NewsIcon />
        {!!hasSeen && <span className="hasSeen"></span>}
      </CustomStyledIconButton>

      {open && (
        <div className="wrapper" id="newsMenu" style={{ height: "400px" }}>
          <div className="title">{t("NAVIGATOR.NEWS")}</div>
          <ul className="list">
            {!newsData.length && (
              <div className="no_news">
                <h4>{t("GENERAL.NO_NEWS")} ☹️</h4>
              </div>
            )}
            {newsData.map((section: INewsData, index: number) => (
              <li
                className="item"
                key={index}
                onClick={() => handleClick(section)}
              >
                <div>
                  {!section.hasSeen && <span className="arrow"></span>}
                  {section.title}
                </div>
              </li>
            ))}
          </ul>
          {data?.data?.total > newsData.length && (
            <span onClick={getMoreNews} className="more_text">
              {t("GENERAL.MORE")}
            </span>
          )}
        </div>
      )}

      <Modal show={modal} onHide={() => setModal(false)} centered={true}>
        <Modal.Body style={{ minHeight: "300px" }}>
          {getByIdStatus === REQUEST_STATUS.loading ? (
            <div className="d-flex justify-content-center align-items-center mt-4">
              <Loader />
            </div>
          ) : (
            <>
              <NewsBoxModal>
                <div className="d-flex gap-3">
                  <img
                    src={
                      process.env.REACT_APP_PRODUCTION_URL +
                      get(getByIdData, "data.image", "")
                    }
                    alt={get(getByIdData, "data.image", "news")}
                    className="news_img w-20"
                  />
                  <h4 className="mb-4 w-80">
                    {get(getByIdData, "data.title", "")}
                  </h4>
                </div>
                <div className="mt-3 news_texts">
                  {get(getByIdData, "data.telegrafUrl", "") ? (
                    <div className="d-flex gap-3">
                      <b>Link:</b>
                      <a
                        href={get(getByIdData, "data.telegrafUrl", "#")}
                        target="_blank"
                      >
                        {get(getByIdData, "data.telegrafUrl", "")}
                      </a>
                    </div>
                  ) : (
                    <p>{parse(get(getByIdData, "data.content", ""))}</p>
                  )}
                </div>
              </NewsBoxModal>
              <div className="d-flex align-items-center justify-content-end mt-3">
                <CancelButton type="button" onClick={() => setModal(false)}>
                  {t("GENERAL.BACK")}
                </CancelButton>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </NewsBoxStyle>
  );
};

export default memo(NewsBox);
